import React, { FC } from 'react'

import { Txt, Icon, ShadedButton } from 'src/components/atoms'

import {
  useCommonContentPage,
  useGetCommonContentPages,
  useGlobalLoading,
  useToast,
} from 'src/hooks'

type Props = {
  commonContentPagesCount: number
  className?: string
}

export const CreateCommonContentPage: FC<Props> = ({ commonContentPagesCount, className }) => {
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()
  const { createCommonContentPage } = useCommonContentPage()
  const { refetch } = useGetCommonContentPages()
  const { displayErrorTextToast } = useToast()

  const handleOnClickCreateCommonContentPage = async () => {
    showGlobalLoading()

    try {
      await createCommonContentPage({ pageOrder: commonContentPagesCount + 1 })
      refetch()
    } catch {
      displayErrorTextToast('共通コンテンツページの作成に失敗しました。')
    } finally {
      hideGlobalLoading()
    }
  }

  return (
    <div className={className}>
      <ShadedButton className="tw-w-full" size="m" onClick={handleOnClickCreateCommonContentPage}>
        <div className="tw-flex tw-items-center">
          <Icon size="--r1" path="plus/soft/line" />
          <Txt sizeType="s" className="tw-font-bold tw-ml-s-3">
            新規追加
          </Txt>
        </div>
      </ShadedButton>
    </div>
  )
}
